<template lang="pug">
    Button.searchChartBtn(
        :icon="searchBtnIcon"
        @click="emitSearchChartData"
        :loading="searchBtnIsLoading"
        :type="searchBtnType"
        :size="searchBtnSize")
        span(v-if="searchBtnText!==''") {{searchBtnText}}
</template>
<script>
import bus from "@/libs/bus.js";

export default {
    name: "SearchChartBtn",
    props: {
        searchBtnText: { type: String, default: "" },
        searchBtnIcon: { type: String, default: "ios-search" },
        searchBtnType: { type: String, default: "primary" },
        searchBtnSize: { type: String, default: "default" }
    },
    components: {},
    data() {
        return {
            searchBtnIsLoading: false
        };
    },
    methods: {
        emitSearchChartData() {
            var self = this;
            this.searchBtnIsLoading = true;
            bus.$emit("searchChartData");
            setTimeout(function() {
                self.searchBtnIsLoading = false;
            }, 3000);
        }
    },
    mounted() {},
    computed: {}
};
</script>




// WEBPACK FOOTER //
// src/components/SearchChartBtn.vue